import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject } from '@angular/core';
import { catchError, EMPTY, map, switchMap } from 'rxjs';
import { OrganizationService } from '../../services/organization.service';
import { OrganizationActions } from '../state/organization/organization.actions';

export const loadActiveOrganization = createEffect(
  (
    actions$ = inject(Actions),
    organizationService = inject(OrganizationService),
  ) => {
    return actions$.pipe(
      ofType(OrganizationActions.getActiveOrganization),
      switchMap(() =>
        organizationService.getActiveOrganization().pipe(
          map((activeOrganization) =>
            OrganizationActions.setActiveOrganization({ activeOrganization }),
          ),
          catchError(() => EMPTY),
        ),
      ),
    );
  },
  { functional: true },
);
